export default "__VITE_ASSET__BADcWgYs__"